export default __webpack_public_path__ + "static/media/notNet.6c18f408.png";